// src/features/medicine-inventory/services/mockData.js
export const mockPatients = [
  {
    id: 'P001',
    patientId: 'PT-1001',
    name: 'John Doe',
    age: 45,
    gender: 'Male',
    contact: '+1234567890',
    address: '123 Main St, New York, NY'
  },
  {
    id: 'P002',
    patientId: 'PT-1002',
    name: 'Jane Smith',
    age: 32,
    gender: 'Female',
    contact: '+1234567891',
    address: '456 Oak Ave, Los Angeles, CA'
  },
  {
    id: 'P003',
    patientId: 'PT-1003',
    name: 'Robert Johnson',
    age: 58,
    gender: 'Male',
    contact: '+1234567892',
    address: '789 Pine Rd, Chicago, IL'
  },
  {
    id: 'P004',
    patientId: 'PT-1004',
    name: 'Maria Garcia',
    age: 29,
    gender: 'Female',
    contact: '+1234567893',
    address: '321 Elm St, Miami, FL'
  },
  {
    id: 'P005',
    patientId: 'PT-1005',
    name: 'David Brown',
    age: 52,
    gender: 'Male',
    contact: '+1234567894',
    address: '654 Cedar Ln, Houston, TX'
  }
];

export const mockVisits = [
  {
    id: 'V001',
    visitId: 'VIS-2024-001',
    patientId: 'P001',
    patientName: 'John Doe',
    visitDate: '2024-03-15T09:30:00Z',
    doctorName: 'Dr. Smith',
    department: 'General Medicine',
    symptoms: 'Fever, cough',
    diagnosis: 'Upper respiratory infection',
    status: 'COMPLETED'
  },
  {
    id: 'V002',
    visitId: 'VIS-2024-002',
    patientId: 'P002',
    patientName: 'Jane Smith',
    visitDate: '2024-03-16T10:15:00Z',
    doctorName: 'Dr. Johnson',
    department: 'Cardiology',
    symptoms: 'Chest pain, shortness of breath',
    diagnosis: 'Hypertension',
    status: 'COMPLETED'
  },
  {
    id: 'V003',
    visitId: 'VIS-2024-003',
    patientId: 'P003',
    patientName: 'Robert Johnson',
    visitDate: '2024-03-16T14:00:00Z',
    doctorName: 'Dr. Williams',
    department: 'Endocrinology',
    symptoms: 'Fatigue, increased thirst',
    diagnosis: 'Type 2 Diabetes',
    status: 'COMPLETED'
  },
  {
    id: 'V004',
    visitId: 'VIS-2024-004',
    patientId: 'P004',
    patientName: 'Maria Garcia',
    visitDate: '2024-03-17T11:30:00Z',
    doctorName: 'Dr. Brown',
    department: 'Neurology',
    symptoms: 'Headache, dizziness',
    diagnosis: 'Migraine',
    status: 'COMPLETED'
  }
];

export const mockPrescriptions = [
  {
    id: 'PR001',
    prescriptionId: 'RX-2024-001',
    visitId: 'V001',
    patientId: 'P001',
    patientName: 'John Doe',
    doctorName: 'Dr. Smith',
    prescriptionDate: '2024-03-15T10:00:00Z',
    medicines: [
      {
        medicineId: '1',
        medicineName: 'Amoxicillin',
        dosage: '500mg',
        frequency: 'Twice daily',
        duration: '7 days',
        quantity: 14,
        instructions: 'Take after food'
      },
      {
        medicineId: '2',
        medicineName: 'Paracetamol',
        dosage: '650mg',
        frequency: 'Three times daily',
        duration: '5 days',
        quantity: 15,
        instructions: 'For fever'
      }
    ],
    status: 'ACTIVE',
    notes: 'Follow up in 1 week'
  },
  {
    id: 'PR002',
    prescriptionId: 'RX-2024-002',
    visitId: 'V002',
    patientId: 'P002',
    patientName: 'Jane Smith',
    doctorName: 'Dr. Johnson',
    prescriptionDate: '2024-03-16T11:00:00Z',
    medicines: [
      {
        medicineId: '3',
        medicineName: 'Aspirin',
        dosage: '75mg',
        frequency: 'Once daily',
        duration: '30 days',
        quantity: 30,
        instructions: 'Take in the morning'
      },
      {
        medicineId: '5',
        medicineName: 'Lisinopril',
        dosage: '10mg',
        frequency: 'Once daily',
        duration: '30 days',
        quantity: 30,
        instructions: 'Take at same time daily'
      }
    ],
    status: 'ACTIVE',
    notes: 'Monitor blood pressure'
  },
  {
    id: 'PR003',
    prescriptionId: 'RX-2024-003',
    visitId: 'V003',
    patientId: 'P003',
    patientName: 'Robert Johnson',
    doctorName: 'Dr. Williams',
    prescriptionDate: '2024-03-16T15:00:00Z',
    medicines: [
      {
        medicineId: '4',
        medicineName: 'Metformin',
        dosage: '500mg',
        frequency: 'Twice daily',
        duration: '90 days',
        quantity: 180,
        instructions: 'Take with meals'
      }
    ],
    status: 'ACTIVE',
    notes: 'Check blood sugar regularly'
  }
];

export const mockCategories = [
  {
    id: '1',
    name: 'Antibiotics',
    description: 'Medicines that fight bacterial infections',
    createdAt: '2024-01-15T10:30:00Z',
    updatedAt: '2024-01-15T10:30:00Z'
  },
  {
    id: '2',
    name: 'Pain Relief',
    description: 'Analgesics and pain management medications',
    createdAt: '2024-01-15T10:30:00Z',
    updatedAt: '2024-01-15T10:30:00Z'
  },
  {
    id: '3',
    name: 'Cardiovascular',
    description: 'Heart and blood pressure medications',
    createdAt: '2024-01-15T10:30:00Z',
    updatedAt: '2024-01-15T10:30:00Z'
  },
  {
    id: '4',
    name: 'Diabetes',
    description: 'Insulin and oral diabetes medications',
    createdAt: '2024-01-15T10:30:00Z',
    updatedAt: '2024-01-15T10:30:00Z'
  }
];

export const mockMedicines = [
  {
    id: '1',
    name: 'Amoxicillin',
    categoryId: '1',
    category: 'Antibiotics',
    manufacturer: 'PharmaCorp',
    unit: 'Capsule',
    price: 5.99,
    currentStock: 150,
    reorderLevel: 50,
    expiryDate: '2025-12-31',
    batchNumber: 'BATCH001',
    createdAt: '2024-01-15T10:30:00Z',
    updatedAt: '2024-01-15T10:30:00Z'
  },
  {
    id: '2',
    name: 'Paracetamol',
    categoryId: '2',
    category: 'Pain Relief',
    manufacturer: 'MediHealth',
    unit: 'Tablet',
    price: 2.99,
    currentStock: 500,
    reorderLevel: 100,
    expiryDate: '2025-06-30',
    batchNumber: 'BATCH002',
    createdAt: '2024-01-15T10:30:00Z',
    updatedAt: '2024-01-15T10:30:00Z'
  },
  {
    id: '3',
    name: 'Aspirin',
    categoryId: '2',
    category: 'Pain Relief',
    manufacturer: 'HealthPharm',
    unit: 'Tablet',
    price: 3.49,
    currentStock: 300,
    reorderLevel: 75,
    expiryDate: '2025-03-31',
    batchNumber: 'BATCH003',
    createdAt: '2024-01-15T10:30:00Z',
    updatedAt: '2024-01-15T10:30:00Z'
  },
  {
    id: '4',
    name: 'Metformin',
    categoryId: '4',
    category: 'Diabetes',
    manufacturer: 'DiabeCare',
    unit: 'Tablet',
    price: 4.99,
    currentStock: 200,
    reorderLevel: 50,
    expiryDate: '2025-09-30',
    batchNumber: 'BATCH004',
    createdAt: '2024-01-15T10:30:00Z',
    updatedAt: '2024-01-15T10:30:00Z'
  },
  {
    id: '5',
    name: 'Lisinopril',
    categoryId: '3',
    category: 'Cardiovascular',
    manufacturer: 'CardioMed',
    unit: 'Tablet',
    price: 6.49,
    currentStock: 120,
    reorderLevel: 40,
    expiryDate: '2025-07-31',
    batchNumber: 'BATCH005',
    createdAt: '2024-01-15T10:30:00Z',
    updatedAt: '2024-01-15T10:30:00Z'
  }
];

export const mockStockMovements = [
  {
    id: '1',
    medicineId: '1',
    medicineName: 'Amoxicillin',
    type: 'PURCHASE',
    quantity: 100,
    unitPrice: 4.50,
    totalPrice: 450.00,
    reference: 'PO-2024-001',
    notes: 'Bulk purchase from supplier',
    createdAt: '2024-02-01T09:15:00Z'
  },
  {
    id: '2',
    medicineId: '1',
    medicineName: 'Amoxicillin',
    type: 'ISSUE',
    quantity: 25,
    patientId: 'P001',
    patientName: 'John Doe',
    visitId: 'V001',
    prescriptionId: 'PR001',
    doctorName: 'Dr. Smith',
    unitPrice: 5.99,
    totalPrice: 149.75,
    notes: 'Patient with infection',
    createdAt: '2024-02-05T14:30:00Z'
  },
  {
    id: '3',
    medicineId: '2',
    medicineName: 'Paracetamol',
    type: 'PURCHASE',
    quantity: 200,
    unitPrice: 1.99,
    totalPrice: 398.00,
    reference: 'PO-2024-002',
    notes: 'Regular stock replenishment',
    createdAt: '2024-02-02T11:00:00Z'
  }
];